// extracted by mini-css-extract-plugin
module.exports = {"root":"AiSummary-desktop-module__root___zwgJV"};